import axios from 'axios';
import environment from '@src/environment';
import { state as planState, mutations as planMutations } from './plan';
import optimizeCloudinaryUrl from '@src/utils/cloudinary-optimizations';

export const state = {
  dishes: [],
  filterOpts: [],
  toggleFilters: false,
  filterQueryString: {},
  isFavoritesVisible: false,
};

export const getters = {
  filterCount(state) {
    let count = 0;
    Object.keys(state.filterQueryString).forEach((group) => {
      count += state.filterQueryString[group].length;
    });
    return count;
  },
};

export const mutations = {
  setDishes(state, value) {
    state.dishes = value;
  },
  setIsFavoritesVisible(state) {
    state.isFavoritesVisible = !state.isFavoritesVisible;
  },
  setFilterOpts(state, value) {
    state.filterOpts = value;
  },
  initializeFilterQueryString(state, value) {
    const initializedObject = {};
    if (state.filterOpts.groups) {
      Object.keys(state.filterOpts.groups).forEach((group) => {
        initializedObject[state.filterOpts.groups[group].requestParameterLabel] = [];
      });
    }

    if (value === 'reset') {
      state.filterQueryString = initializedObject;
    } else {
      state.filterQueryString = initializedObject
        ? { ...initializedObject, ...buildFilterOpts(this.state.user.preferences) }
        : { ...buildFilterOpts(this.state.user.preferences) };
    }
  },
  setFilterQueryString(state, value) {
    state.filterQueryString = value;
  },
  setToggleFilters(state) {
    state.toggleFilters = !state.toggleFilters;
  },
  handleError(state, newValue) {
    this.state.errors.serverError = newValue;
  },
};

export const actions = {
  async getDishes(ctx) {
    return await axios
      .get(`${environment.DISHES_URL}?filterOptions=${JSON.stringify(ctx.state.filterQueryString)}`)
      .then((res) => {
        res.data.map((dish) => {
          dish.imageurl = optimizeCloudinaryUrl(dish.imageurl);
          return dish;
        });

        return ctx.commit('setDishes', res.data);
      })
      .catch((err) => {
        err.retry.enabled = true;
        ctx.commit('handleError', err);
        console.log(err);
      });
  },
  async addDish(ctx, payload) {
    if (planState.userRequestClearPlan) {
      payload.planDayId = undefined;
      planMutations.setUserRequestClearPlan(planState, false);
    }
    return await axios
      .post(`${environment.ADD_DISH_URL}`, payload)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
  async removeDish(ctx, dishId) {
    return await axios
      .post(`${environment.REMOVE_DISH_URL}`, { dishId })
      .then((res) => res.data)
      .catch((err) => {
        err.retry.enabled = true;
        ctx.commit('handleError', err);
        console.log(err);
      });
  },
  async getFilterOpts(ctx, {} = {}) {
    return await axios
      .get(`${environment.DISHES_FILTERS_URL}`)
      .then((res) => {
        ctx.commit('setFilterOpts', res.data);
        ctx.commit('initializeFilterQueryString');
      })
      .catch((err) => console.log(err));
  },
  async adjustLeftovers(ctx, { id, payload }) {
    return await axios
      .post(`${environment.PLANNED_DISHES_URL}/${id}/adjust-leftovers`, payload)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
};

function getSelectedPrefs(preferences, filterOpt) {
  const selectedPrefIds = new Set(preferences.filter((pref) => pref.isSelected && pref.filterOption === filterOpt).map((pref) => pref.filterOptionId));
  return [...selectedPrefIds];
}

function buildFilterOpts(preferences) {
  const selectedPrefs = {
    includeDiets: getSelectedPrefs(preferences, 'includeDiets'),
    includeHealths: getSelectedPrefs(preferences, 'includeHealths'),
    includeGoals: getSelectedPrefs(preferences, 'includeGoals'),
  };
  return selectedPrefs;
}
